import React, { useState } from "react";

export default function JellyRadio({ items = [], defaultValue, value: controlledValue, onChange, chipColor = "#27272a", activeColor = "#f5f5f5", textColor = "#f5f5f5", activeTextColor = "#18181b", size = "md", gap = 8, radius = 18, swell = 0.2, barge = 6, shrink = 0.05, jelly = 1, bounce = 0.25, stagger = 22, stiffness = 580, label = "Choose an option" }) {
	const normalized = items.map((item) => typeof item === "string" ? { value: item, label: item } : item);
	const [internalValue, setInternalValue] = useState(defaultValue ?? normalized[0]?.value);
	const selectedValue = controlledValue ?? internalValue;

	return (
		<div className={`solufy-jelly-radio solufy-jelly-radio--${size}`} role="radiogroup" aria-label={label} style={{ "--jelly-chip": chipColor, "--jelly-active": activeColor, "--jelly-text": textColor, "--jelly-active-text": activeTextColor, "--jelly-gap": `${gap}px`, "--jelly-radius": `${radius}px`, "--jelly-swell": swell, "--jelly-barge": `${barge}px`, "--jelly-shrink": shrink, "--jelly-duration": `${Math.max(240, 900 - stiffness)}ms`, "--jelly-bounce": bounce, "--jelly-strength": jelly, "--jelly-stagger": `${stagger}ms` }}>
			{normalized.map((item, index) => {
				const active = item.value === selectedValue;
				return (
					<button key={item.value} type="button" role="radio" aria-checked={active} disabled={item.disabled} className={`solufy-jelly-radio__option${active ? " is-active" : ""}`} style={{ "--item-index": index }} onClick={() => {
						if (item.disabled) return;
						setInternalValue(item.value);
						onChange?.(item.value, index);
					}}>
						{item.icon ? <span className="solufy-jelly-radio__icon" aria-hidden="true">{item.icon}</span> : null}
						<span>{item.label}</span>
					</button>
				);
			})}
		</div>
	);
}
